import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, FormControl, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../../../../core/_base/crud';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { Cache } from 'aws-amplify';
import { SettingsHttpService } from '../../../../core/settings/_services/settings-http.service';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { environment } from '../../../../../environments/environment';
import { MachineSelectionDialogComponent } from './machine-selection-dialog/machine-selection-dialog.component';
import { Location } from '@angular/common';
import { result } from 'lodash';
import { error } from 'console';
import { MixpanelService } from '../../../../services/mixpanel.service';

@Component({
  selector: 'kt-machine-details',
  templateUrl: './machine-details.component.html',
  styleUrls: ['./machine-details.component.scss']
})
export class MachineDetailsComponent implements OnInit {

	editInfoForm: FormGroup;

	private dialogConfig = new MatDialogConfig();

	matcher = new MyErrorStateMatcher();

	regions: any[] = [];

	territories: any[] = [];

	isAuthorized = false;

	selectedMachine: any;

	userRole = Cache.getItem('userAttr')['custom:role'];

	roleIndex;

	selectedDisti;
	selectedMarket;
	selectedClient;
	selectedCampus;
	macObj;
	campLoc;

	// @ViewChild('form', {static: true}) form;
	@ViewChild(FormGroupDirective, {static: false}) formDirective: FormGroupDirective;

	user;
	role;

	timeZoneObj = [
		{label: 'Atlantic Time Zone(No DST)', value: 'America/Puerto_Rico'},
		{label: 'Atlantic Time Zone(With DST)', value: 'America/Halifax'},
		{label: 'Eastern Time Zone', value: 'America/New_York'},
		{label: 'Central Time Zone', value: 'America/Chicago'},
		{label: 'Mountain Time Zone(With DST)', value: 'America/Denver'},
		{label: 'Mountain Time Zone(No DST)', value: 'America/Phoenix'},
		{label: 'Pacific Time Zone', value: 'America/Los_Angeles'},
		{label: 'Alaskan Time Zone', value: 'America/Los_Angeles'},
		{label: 'Hawaiian Time Zone', value: 'Pacific/Honolulu'},
		{label: 'Western European Time Zone(No DST)', value: 'Atlantic/Reykjavik'},
		{label: 'Western European Time Zone(With DST)', value: 'Europe/London'},
		{label: 'Central European Time Zone', value: 'Europe/Paris'}
	  ];

	macStats = [
		{label: 'Production', value: 2},
		{label: 'Warehouse', value: 1}
	]

  constructor(public dialog: MatDialog, private http: SettingsHttpService, private cdr: ChangeDetectorRef,
	private _snackBar: MatSnackBar, private route: ActivatedRoute, private location: Location,
	private mixpanelService: MixpanelService, private machineRouteService: MachineRouteService) {
	  this.roleIndex = environment.roles.indexOf(this.userRole);
  }

  ngOnInit() {
	this.selectedMachine = this.machineRouteService.getMachine(this.route);
	if (!this.selectedMachine) return;

	this.user = Cache.getItem('userAttr');
	this.role = this.user['custom:role'];

	this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, {
		machineName: this.selectedMachine.machine_name,
		machineId: this.selectedMachine.machine_id,
		serialNo: this.selectedMachine.serial_no
	});

	this.editInfoForm = new FormGroup({
		'machine_id' : new FormControl(null, Validators.required),
		'serial_no' : new FormControl(null, Validators.required),
		'disti_id': new FormControl(null, Validators.required),
		'market_id': new FormControl(null),
		'client_id': new FormControl(null, Validators.required),
		'campus_id': new FormControl(null, Validators.required),
		'machine_name' : new FormControl(null),
		'time_zone' : new FormControl(null, Validators.required),
		'address_line1' : new FormControl(null, Validators.required),
		'address_line2' : new FormControl(null),
		'city' : new FormControl(null, Validators.required),
		'state' : new FormControl(null, Validators.required),
		'zip_code' : new FormControl(null, Validators.required),
		'mac_status': new FormControl(null, Validators.required)
	});

	this.getMachineDet();

  }

  getCampusDet(){
	this.http.getCampusLocation(this.selectedCampus.campus_id)
	.subscribe(result =>{
		// console.log("Campus Details:", result);
		this.campLoc = result[0]
		this.editInfoForm.patchValue({
			'address_line1': this.campLoc.address_line1,
            'address_line2': this.campLoc.address_line2,
            'city': this.campLoc.city,
            'state': this.campLoc.state,
            'zip_code': this.campLoc.zipcode
		});
	}, error =>{
		console.log("Error Fetching Campus: ", error);
		this.showSnackBar(error, 500);
	})
  }

  getMachineDet() {
	this.http.getMachineDet(this.selectedMachine.machine_id)
	.subscribe(det => {
		this.macObj = det;
		this.editInfoForm.patchValue({
			'machine_id' : det.machine_id_display || det.machine_id,
			'serial_no' : det.serial_no,
			'disti_id': det.disti_name,
			'market_id': det.market_name || null,
			'client_id': det.company_name,
			'campus_id': det.campus_name,
			'machine_name' : det.machine_name,
			'time_zone' : det.time_zone,
			'address_line1' : det.address_line1,
			'address_line2' : det.address_line2,
			'city' : det.city,
			'state' : det.state,
			'zip_code' : det.zipcode,
			'mac_status': det.mac_status
		});
		// Initialize all selected objects from loaded data
		if(det.disti_id){
			this.selectedDisti = {disti_id: det.disti_id, name: det.disti_name};
		}
		if(det.market_id){
			this.selectedMarket = {market_id: det.market_id, market_name: det.market_name};
		}
		if(det.client_id){
			this.selectedClient = {client_id: det.client_id, company_name: det.company_name};
		}
		if(det.campus_id){
			this.selectedCampus = {campus_id: det.campus_id, name: det.campus_name};
		}
	});
  }

  	openDialog(txt){
		// Market admin can only change client and campus
		if(this.role === 'marketadmin' && (txt === 'disti' || txt === 'market')){
			return; // Don't allow market admin to change partner or market
		}
		
		// For market selection, check if we have a partner (either selectedDisti or from macObj)
		if(txt == 'market'){
			if(!this.selectedDisti && this.macObj && this.macObj.disti_id){
				// Use the partner from the loaded machine data
				this.selectedDisti = {disti_id: this.macObj.disti_id, name: this.macObj.disti_name};
			}
			if(!this.selectedDisti){
				this.showSnackBar('Please select the partner first.', 3000);
				return;
			}
		}
		// For market admin, client selection doesn't require partner
		if(txt == 'client' && !this.editInfoForm.get('disti_id').value && this.role !== 'marketadmin'){
			this.showSnackBar('Please select the partner first.', 3000);
			return;
		}else{
			if(!this.selectedDisti && this.role !== 'marketadmin')
				this.selectedDisti = {disti_id: this.macObj.disti_id}
		}
		if(txt == 'campus' && !this.editInfoForm.get('client_id').value){
			this.showSnackBar('Please select the client first.', 3000);
			return;
		}else{
			if(!this.selectedClient)
				this.selectedClient = {client_id: this.macObj.client_id}
		}

		this.dialogConfig.autoFocus = true;
		// For market admin, pass their market_id
		const dialogData: any = {show: txt, showTill: txt, disti: this.selectedDisti, market: this.selectedMarket, client: this.selectedClient, all: false, bckBtn: false};
		if(this.role === 'marketadmin' && this.user['custom:market_id']){
			dialogData.market = {market_id: parseInt(this.user['custom:market_id'], 10)};
		}
		this.dialogConfig.data = dialogData;
		this.dialogConfig.maxWidth = "90vh";
		this.dialogConfig.maxWidth = "650px";

		const dialogRef = this.dialog.open(MachineSelectionDialogComponent, this.dialogConfig);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			} else {
				if(res.data.disti){
					this.selectedDisti = res.data.disti;
					this.editInfoForm.patchValue({'disti_id':res.data.disti.name});
					this.selectedMarket = null;
					this.editInfoForm.patchValue({'market_id': null});
					this.selectedClient = null;
					this.editInfoForm.patchValue({'client_id': null});
					this.selectedCampus = null;
					this.editInfoForm.patchValue({'campus_id': null});
				}
				if(res.data.market){
					this.selectedMarket = res.data.market;
					this.editInfoForm.patchValue({'market_id': res.data.market.market_name});
					// Reset client and campus when market changes
					this.selectedClient = null;
					this.editInfoForm.patchValue({'client_id': null});
					this.selectedCampus = null;
					this.editInfoForm.patchValue({'campus_id': null});
				}
				if(res.data.client){
					this.selectedClient = res.data.client;
					this.editInfoForm.patchValue({'client_id':res.data.client.company_name});
					// Only clear campus when client changes, preserve disti and market if not provided
					this.selectedCampus = null;
					this.editInfoForm.patchValue({'campus_id': null});
				}
				if(res.data.campus){
					// Only update if new values are provided, otherwise preserve existing
					if(res.data.disti){
						this.selectedDisti = res.data.disti;
						this.editInfoForm.patchValue({'disti_id': res.data.disti.name});
					}
					if(res.data.market){
						this.selectedMarket = res.data.market;
						this.editInfoForm.patchValue({'market_id': res.data.market.market_name});
					}
					if(res.data.client){
						this.selectedClient = res.data.client;
						this.editInfoForm.patchValue({'client_id': res.data.client.company_name});
					}
					// Always update campus when selected
					this.selectedCampus = res.data.campus;
					this.editInfoForm.patchValue({'campus_id':res.data.campus.name});
					this.getCampusDet();
				}
				this.cdr.detectChanges();
			}
		});
	}

  onBack() {
	this.location.back();
	// this.formDirective.resetForm();
  }

  onSubmited() {
	if (this.editInfoForm.valid) {
		let obj = this.editInfoForm.value;
		if(this.selectedDisti)
		obj.disti_id = this.selectedDisti.disti_id;
		else
		obj.disti_id = null;
		if(this.selectedMarket)
		obj.market_id = this.selectedMarket.market_id;
		else
		obj.market_id = null;
		if(this.selectedClient)
		obj.client_id = this.selectedClient.client_id;
		else
		obj.client_id = null;
		if(this.selectedCampus)
		obj.campus_id = this.selectedCampus.campus_id;
		else
		obj.campus_id = null;

		this.http.updateMachineDet(obj)
		.subscribe(result => {
			this.showSnackBar('Info updated successfully.', 0);
			// this.formDirective.resetForm();
		}, error => {
			console.log(error);
			this.showSnackBar((error.message || JSON.stringify(error) || 'Something went wrong.'), 0);
		});

	} else {
		this.showSnackBar('Please fill all the fields',3000);
	}
  }


  	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

}
